import { FileReader, FileWriter } from '@/platform'
import FileName from '../ComControl/FileName'
import ActionDetail from './ActionDetail'

class OafDetail {
    public OafName: string = '' // 动图名称
    public ActionList: ActionDetail[] = [] // 动作列表
    public FaultTolerantGraph: FileName = new FileName({ type: FileName.DEF_TYPE, name: '' }) // 容错图

    readBin(reader: FileReader): void {
        reader.readInt()
        this.OafName = reader.readString()
        const count = reader.readInt()
        if (count > 0) {
            for (let index = 0; index < count; index++) {
                const actionDetail = new ActionDetail()
                actionDetail.readBin(reader)
                this.ActionList.push(actionDetail)
            }
        }
        this.FaultTolerantGraph.readBin(reader)
    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(4)

        writer.writeString(this.OafName)

        writer.writeInt(this.ActionList.length)
        for (let i = 0; i < this.ActionList.length; i++) {
            const action = this.ActionList[i]
            action.writeBin(writer)
        }
        this.FaultTolerantGraph.writeBin(writer)
    }

    readVersionedOui(reader: FileReader): void {
        this.OafName = reader.readString()
        const count = reader.readInt()
        if (count > 0) {
            for (let index = 0; index < count; index++) {
                const actionDetail = new ActionDetail()
                actionDetail.readVersionedOui(reader.readObj(reader.readInt()))
                this.ActionList.push(actionDetail)
            }
        }

        this.FaultTolerantGraph.readVersionedOui(reader.readObj(reader.readInt()))
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()
        writer.writeString(this.OafName)
        writer.writeInt(this.ActionList.length)
        for (let i = 0; i < this.ActionList.length; i++) {
            const action = this.ActionList[i]
            action.writeVersionedOui(writer)
        }
        this.FaultTolerantGraph.writeVersionedOui(writer)
        writer.writerLength()
    }

    writeMallBin(writer: FileWriter): void {
        this.writeVersionedOui(writer)
    }
}

export default OafDetail
